import { Ionicons } from "@expo/vector-icons";
// NOTE: Adding @sentry/react to the dependencies causes an error because of dependencies it installs.
// Our other sentry dependencies (@sentry/react-native) already install @sentry/react so we can ignore this error.
// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from "@sentry/react";
import { Box, HStack, Icon, Pressable, Text, VStack } from "native-base";
import React from "react";
import { useTranslation } from "react-i18next";
import { ActivityIndicator } from "react-native";

import { HORMONE_HEX_COLOR } from "../constants/theme";
import { useExternalLink } from "../hooks/useExternalLink";

const BlogLinksDropdown = (): JSX.Element => {
  const { t } = useTranslation();
  const { isLoading, error, openLink } = useExternalLink();

  const blogs = [
    {
      label: t("my_profile.blogs.menopause"),
      href: "https://killerbodyfood.com/blogs/voedingstips/tagged/menopause",
    },
    {
      label: t("my_profile.blogs.cycle"),
      href: "https://killerbodyfood.com/blogs/voedingstips/tagged/menstruatiecyclus",
    },
    {
      label: t("my_profile.blogs.weightloss"),
      href: "https://killerbodyfood.com/blogs/voedingstips",
    },
  ];

  return (
    <VStack width="100%" space={3} mt={2}>
      <Text fontWeight="medium" fontSize="md">
        {t("my_profile.blogs.title")}
      </Text>

      {error ? (
        <Text color="error.500" fontSize="sm" mb={1}>
          {error}
        </Text>
      ) : null}

      {blogs.map((blog) => (
        <Pressable
          key={blog.href}
          onPress={() => {
            openLink(blog.href).catch((err) => {
              console.error("Failed to open URL:", err);
              Sentry.captureException(err);
            });
          }}
          testID={`blog-link-${blog.label}`}
        >
          {({ isPressed }) => (
            <HStack
              p={3}
              borderRadius="md"
              borderWidth={1}
              borderColor={`${HORMONE_HEX_COLOR}30`}
              bg={isPressed ? `${HORMONE_HEX_COLOR}30` : `${HORMONE_HEX_COLOR}15`}
              alignItems="center"
              space={3}
              shadow={1}
            >
              <Box bg="white" p={2} borderRadius="full">
                <Icon as={Ionicons} name="newspaper-outline" size="md" color={HORMONE_HEX_COLOR} />
              </Box>

              <VStack flex={1}>
                <Text fontWeight="medium">{blog.label}</Text>
              </VStack>

              {isLoading === blog.href ? (
                <ActivityIndicator size="small" />
              ) : (
                <HStack alignItems="center" space={1}>
                  <Icon as={Ionicons} name="open-outline" size="sm" color={HORMONE_HEX_COLOR} />
                </HStack>
              )}
            </HStack>
          )}
        </Pressable>
      ))}
    </VStack>
  );
};

export default BlogLinksDropdown;
